import { Einheit } from 'app/models/core/einheit.model';
import { BnrGpPosModel } from '../bnr.gp.pos.model';
import { PosUnDef } from '../gp';
import Config from 'Config';
const posDef: BnrGpPosModel[] = [];

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'ausMaxi',
		posText: 'Systematische Vertriebsunterstützung',
		planKey: 'vertriebsunterstz_i',
		einheit: Einheit.quali,
		posDesc: `Aktive Unterstützung der ABV Hauptverwaltung bei strategischen Schwerpunkten zur systematischen Vertriebssteuerung in den Agenturen.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'ausMaxi',
		posText: 'Kundenansprache und Agenturprozesse',
		planKey: 'agenturprozesse',
		einheit: Einheit.quali,
		posDesc: `Multiplikator:in und Ansprechpartner:in im Verantwortungsbereich für die Gestaltung kundenorientierter Agenturabläufe. Verantwortung für die Etablierung von Anwendungen zur Steigerung der Kundenzufriedenheit und des Kundenkontakts. Förderung von Maßnahmen zur Erhebung von Kundenfeedback. Identifizierung von Best-Practices und deren Multiplikatoren im Verantwortungsbereich`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'ausMaxi',
		posText: 'Vertreteraktivierung in den Wachstumsdimensionen',
		planKey: 'vertreteraktivierung',
		einheit: Einheit.quali,
		posDesc: `Multiplikator:in und Ansprechpartner:in für die Vertriebseinheiten innerhalb der VD für den strategischen Einsatz aller digitalen und analogen Instrumente der Wachstumsdimensionen. Unterstützung und Beratung in der Nutzung der Instrumente durch gezielte Einsteuerung und Multiplikation von Neuerungen und Best-Practices.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 10010,
		group: 'max8k',
		posText: 'Sichtbar sein digital.persönlich - Steigerung der digitalen Sichtbarkeit I',
		berichtePath: 'kunde/sm/gupmultigp/',
		einheit: Einheit.proz,
		boniStufen: 2,
		posDesc: `Steigerung der Anzahl GV/HV mit kontinuierlichem Zuwachs an Google Bewertungen im Verantwortungsbereich. Stichtag der Bemessungsgrundlage für das Jahresziel ist der GV/HV Bestand zum 01.01.2026`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 10020,
		group: 'max8k',
		posText: 'Sichtbar sein digital.persönlich - Steigerung der digitalen Sichtbarkeit II',
		berichtePath: 'kunde/sm/viewsmultigp/',
		einheit: Einheit.proz,
		boniStufen: 2,
		posDesc: `Anzahl GV/HV mit mehr als 30.000 Sichtkontakten über die Social Media Kanäle Facebook und Instagram Stichtag der Bemessungsgrundlage für das Jahresziel ist der GV/HV Bestand zum 01.01.2026`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max8k',
		posText: 'Jeden Kontakt nutzen I - Schulung und Unterstützung bei der Einrichtung des neuen technischen Arbeitsplatzes',
		berichtePath: 'bestand/fit/amisnowaufgaben/',
		einheit: Einheit.quali,
		posDesc: `Durchführen von geeigneten Schulungsmaßnahmen im Rahmen der vorhanden Vorgaben des neuen technischen Arbeitsplatzes. Eigeninitiative und Innovationsbereitschaft in der Breitenmultiplikation bspw. durch die Organisation von digitalen und physischen Events zum sicheren Einsatz in der Verwendung zur Steigerung der Nettovertriebszeit.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max8k',
		posText: 'Jeden Kontakt nutzen II - Unterstützung bei der fachlichen Weiterentwicklung von AMIS.NOW',
		berichtePath: 'bestand/fit/amisnowaufgaben/',
		einheit: Einheit.quali,
		posDesc: `Durchführen von Schulungsmaßnahmen zum erfolgreichem Einsatz von AMIS.NOW im Verantwortungsbereich. Eigeninitiative und Innovationsbereitschaft in der Breitenmultiplikation von AMIS.NOW bspw. durch die Organisation von digitalen und physischen Events im Verantwortungsbereich. Befähigung und Beratung beim Einsatz von AMIS.NOW Aufgaben im Verantwortungsbereich.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max8k',
		posText: 'Jeden Kontakt nutzen III - Förderung von Vertriebschancen im Agenturteam',
		berichtePath: 'bestand/fit/amisnowaufgaben/',
		einheit: Einheit.quali,
		posDesc: `Multiplikator:in und Ansprechpartner:in für Service-to-Sale. Förderung von Vertriebschancen im gesamten Agenturteam durch Einsteuerung und Nachhalten geeigneter Maßnahmen im Verantwortungsbereich`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 10030,
		group: 'max8k',
		posText: 'Jeden Kunden kontaktieren - Steigerung der Cross-Selling-Quote und Kundenbindung',
		berichtePath: 'kunde/akuma/gp/',
		einheit: Einheit.proz,
		posDesc: `Anzahl GV/HV mit wiederkehrender AKUMA Nutzung in der VD plus Anzahl GV/HV an AKUMA.Prime. (wiederkehrende AKUMA Planer Nutzung von mindestens 12 Wochen im Jahr 2026) Stichtag der Bemessungsgrundlage für das Jahresziel ist der GV/HV Bestand zum 01.01.2026`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2315160, // wird geliefert
		group: 'max8k',
		posText: 'Immer da sein - Neuanmeldungen Meine Allianz',
		berichtePath: 'bestand/adz/fit/maz/',
		einheit: Einheit.stck,
		posDesc: `Steigerung der Durchdringung von Kunden mit Meine Allianz im Bestand Basis Jahresanfangsbestand 01.01.2026`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max8k',
		posText: 'Immer da sein - Öffnungszeiten effektiv verlängern',
		planKey: 'openinghours',
		einheit: Einheit.quali,
		posDesc: `Förderung und Multiplikation von Serviceleistungen im Bereich Inbound. Förderung von Erreichbarkeit im Verantwortungsbereich durch Einsteuerung und Nachhalten geeigneter Maßnahmen.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 10040,
		group: 'max8k',
		posText: 'Neue Kunden finden - Förderung der Neukundengewinnung',
		berichtePath: 'kunde/leadnow/consecutive/',
		einheit: Einheit.proz,
		boniStufen: 2,
		posDesc: `Steigerung der Neukundengewinnung mit AMIS.NOW.Leads. Anzahl Agenturen von AMIS.NOW.Leads im Verantwortungsbereich mit einer Teilnahme von mind. 12 Wochen am Stück Stichtag der Bemessungsgrundlage für das Jahresziel ist der GV/HV Bestand zum 01.01.2026`,
	}),
);

export const EdtPositionen = posDef;
